import { Module } from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { State } from '@/main/store'
import { CartDataInitialState } from './types'
const cartStore: Module<CartDataInitialState, State> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
export default cartStore
